// src/utils/useAxios.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

class AxiosService {
    static instance = null;

    constructor() {
        this.api = axios.create({
            baseURL: BASE_URL,
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }

    static getInstance() {
        if (!AxiosService.instance) {
            AxiosService.instance = new AxiosService();
        }
        return AxiosService.instance;
    }

    getApi() {
        return this.api;
    }
}

export const axiosService = AxiosService.getInstance();
export const api = axiosService.getApi();

export default axiosService;
